import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './permission'

Vue.use(ElementUI, { size: 'medium' })

// 全局事件总线：顶部的「小程序 / 渠道应用」选择器切换后，用它通知当前页面重新拉数据。
// layout/index.vue 一直在 emit，之前没有注册过 $bus，那些事件其实全部落空，
// 表现就是切换应用后列表不刷新，必须手动刷新页面才生效。
Vue.prototype.$bus = new Vue()

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
